// extracted by mini-css-extract-plugin
export var container = "_mr-0";